<h1 class="mat-dialog-title">Vælg komponenttype</h1>

<mat-dialog-content>
    <komponent-typer [komponentTyper]="data.komponentTyper" (vaelg)="onVaelg($event)"> </komponent-typer>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button type="button" [mat-dialog-close] tabindex="-1">ANNULLER</button>
</mat-dialog-actions>
